module.exports = __webpack_public_path__ + "static/media/next.c1130b17.svg";